<div class="composer-toolbar">
  <div class="left">
    <h1>Email Composer</h1>
  </div>

  <div class="center">
    <div class="tabs">
      <button class="tab" [class.active]="isTemplatesViewActive()" nbButton size="small" status="basic" (click)="switch('templates')">TEMPLATES</button>
      <button class="tab" [class.active]="isComponentsViewActive()" nbButton size="small" status="basic" (click)="switch('components')">COMPONENTS</button>
      <button class="tab" [class.active]="isThemesViewActive()" nbButton size="small" status="basic" (click)="switch('themes')">THEMES</button>
      <button class="tab" [class.active]="isActionsViewActive()" nbButton size="small" status="basic" (click)="switch('actions')">ACTIONS</button>
    </div>
  </div>

  <div class="right">
    <div class="search-pill">
      <nb-icon class="prefix" icon="search-outline"></nb-icon>
      <input type="text" [ngModel]="search" (ngModelChange)="onSearch($event)" placeholder="Search" />
      <button class="clear-btn" *ngIf="search" (click)="onSearch('')" nbTooltip="Clear" nbTooltipPlacement="bottom">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </div>
</div>
